<!--
 * @Author: your name
 * @Date: 2020-09-24 13:19:16
 * @LastEditTime: 2020-12-03 17:46:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qh-wbactive\src\page\marketact\yellowposter.vue
-->
<template>
    <div class="page">
        <div class='imgwrap'>
            <img :src="formatUrl(shareUrl)" class='shareSize' alt="">
        </div>
    </div>
</template>

<script>
import services from './services';

export default {
    components: {
    },
    data() {
        return {
            shareUrl: {}
        };
    },
    methods: {
        getData() {
            services.getDailyCoverUrl().then(res => {
                this.shareUrl = res.data.data.picUrl;
            });
        },
        formatUrl(jsonStr) {
            try {
                const imgs = JSON.parse(jsonStr);
                return imgs.o || imgs.m || '';
            }
            catch (error) {
                return '';
            }
        }
    },
    mounted() {
        this.getData();
    }
};
</script>

<style lang="stylus" scoped>
.page
    size 100%
    .imgwrap
        width 100%
        height 100%
        .shareSize
            width 100%
            height 100%
            object-fit contain
</style>
